import { editPilotoService } from "../api/services/piloto";
import handleMessages from "../utils/HandleMessages";

const usePiloto = () => {
  const editPiloto = async (data) => {
    const res = await editPilotoService(data);
    return handleMessages(res);
  };

  return {
    editPiloto,
  };
};

export default usePiloto;
